const learningMaterialsArr = [
    {
        descr: `Автоматизация звука [Л] в прямых слогах:
        - ЛА – ЛА – ЛА – ЛА
        - ЛЫ – ЛЫ – ЛЫ – ЛЫ
        - ЛО – ЛО – ЛО – ЛО
        - ЛУ – ЛУ – ЛУ – ЛУ
        В обратных слогах:
        - АЛ – АЛ – АЛ – АЛ
        - ИЛ – ИЛ – ИЛ – ИЛ
        - ОЛ – ОЛ – ОЛ – ОЛ
        - УЛ – УЛ – УЛ – УЛ
        - ЕЛ – ЕЛ – ЕЛ – ЕЛ
        
        В интервокальных слогах:
        - АЛА – АЛО – АЛЫ – АЛУ
        - УЛА – УЛО – УЛЫ – УЛУ 
        - ОЛА – ОЛО – ОЛЫ – ОЛУ
        - ЫЛА – ЫЛО – ЫЛЫ – УЛУ
        
        С сочетанием согласных:
        - КЛА – КЛО – КЛУ – КЛЫ
        - СЛУ – СЛА – СЛЫ – СЛО
        - ФЛО – ФЛУ – ФЛА – ФЛЫ
        - ХЛЫ – ХЛА – ХЛО – ХЛЫ
        - ПЛЫ – ПЛУ – ПЛО – ПЛА
        
        Автоматизация звука [ЛЬ] в прямых слогах:
        - ЛЯ – ЛЯ – ЛЯ –ЛЯ
        - ЛИ – ЛИ – ЛИ – ЛИ
        - ЛЁ –ЛЁ –ЛЁ - ЛЁ - ЛО
        - ЛЮ – ЛЮ –ЛЮ –ЛЮ 
        
        В обратных слогах:
        - АЛЬ – АЛЬ – АЛЬ – АЛЬ
        - ИЛЬ – ИЛЬ – ИЛЬ– ИЛЬ
        - ОЛЬ – ОЛЬ – ОЛЬ – ОЛЬ
        - УЛЬ – УЛЬ – УЛЬ – УЛЬ
        - ЕЛЬ – ЕЛЬ – ЕЛЬ – ЕЛЬ
        
        С сочетанием согласных:
        - КЛЯ – КЛЁ – КЛЮ – КЛИ
        - СЛЮ – СЛЯ – СЛИ – СЛЁ
        - ФЛЁ – ФЛЮ – ФЛЯ – ФЛИ
        - ХЛИ – ХЛЯ – ХЛЁ – ХЛИ
        - ПЛИ – ПЛЮ – ПЛЁ – ПЛЯ
        `
    },
    {
        descr: `Слова для автоматизации звука [Л]:
        1. Лампа
        2. Луна
        3. Лыжи
        4. Лодка
        5. Лавка
        6. Лом
        7. Ложка
        8. Лапа
        9. Лошадь
        10. Лунтик
        
        Слова для автоматизации звука [Ль]:
        1. Лист
        2. Лёд
        3. Лиса
        4. Лестница
        5. Лепесток
        6. Лёгкий
        7. Лень
        8. Лилия
        9. Лекарь
        10. Лён
        `
    },
    {
        descr: `Предложения для автоматизации звука [Л]:
        1. Лампа горит ярко.
        2. Луна светит ночью.
        3. Мы купили новые лыжи.
        4. Лодка плывёт по реке.
        5. Лавка стоит у дома.
        6. Лес шумит от ветра.
        7. Ложка лежит на столе.
        8. Лапа кота мягкая.
        9. Лошадь пасётся в поле.
        10. Лунтик прилетел на землю.
        
        Предложения для автоматизации звука [Ль]:
        1. Лист дерева зелёный.
        2. Лёд на озере тает.
        3. Лиса бегает по лесу.
        4. Лестница ведёт наверх.
        5. Лепесток розы упал.
        6. Лёгкий ветерок дует.
        7. Лень мешает работать.
        8. Лилия цветёт в саду.
        9. Лекарь лечит больных.
        10. Лён растёт на поле.
        `
    },
    {
        descr: `Летом Лена и Лёша отправились в лес. Они взяли с собой корзину и решили собрать лисички и ландыши. Лес был густой, но очень красивый. Лена нашла большую поляну, где росли ландыши. Лёша в это время собирал грибы. Вдруг Лена услышала шорох и увидела лису. Лиса смотрела на детей, но не подходила ближе. Лёша предложил Лене вернуться к лавке у входа в лес, чтобы передохнуть. Они сели на лавку, достали лимонад и стали обсуждать свои находки. Вечером, когда солнце начало садиться, дети отправились домой. Луна уже начала подниматься над лесом, освещая дорогу своим мягким светом. Лена и Лёша были довольны своим днём и планировали вернуться в лес на следующей неделе.
        Стихотворение со звуками Л и ЛЬ: 
        Лодка по реке плывет,
        Лёгкий бриз её несёт,
        Ласковый луч солнца
        Ласкает берег нежно.
        `
    },
    {
        descr: `йа – йа – йа
        йо – йо – йо 
        йу – йу – йу 
        йэ – йэ – йэ
        ай – ай – ай  
        ой – ой – ой
        ай – ой –ей
        ей – ий – ой
        ий – ай – ей
        ой – ий – ай
        Примеры слов со звуком Й:
        1. Ель
        2. Ева
        3. Емеля
        4. Пей
        5. Лей
        6. Сей
        7. Ещё
        8. Ёж
        9. Ёлка
        10. Пьёт
        11. Пью
        12. Юг
        13. Юля
        14. Юла
        15. Юбка
        16. Каюта
        17. Магия
        18. Вьюга
        19. Вьётся
        20. Шагает
        `
    },
    {
        descr: `1. Яркий ёжик
        2. Красивая девушка
        3. Юный герой
        4. Мягкий плед
        5. Сияющая звезда
        6. Летящий самолёт
        7. Пёстрый ковёр
        8. Поющий соловей
        9. Гуляющий пёс
        10. Приятный аромат
        
        Звук Й в предложениях:
        1. Яркий ёжик спрятался под кустом.
        2. Девушка пьёт ароматный чай.
        3. Юный герой совершил подвиг.
        4. Кошка мягко мурлыкает на пледе.
        5. В небе сияет яркая звезда.
        6. Евгений улетел на Ямайку.
        7. Пёстрый ковёр украшает комнату.
        8. В саду поёт соловей.
        9. Пёс весело гуляет по парку.
        10. В воздухе витает вкусный аромат цветов.
        `
    },
    {
        descr: `<span>Йожик и йод</span>
        Жил-был в лесу ёжик по имени Йося. Йося был очень любопытным ёжиком и мечтал попробовать всё на свете. Однажды, гуляя по лесу, он нашёл под ёлкой маленькую коробочку. 
        "Ой, что это?" - пропищал Йося и, недолго думая, открыл её. Внутри лежал пузырёк с тёмной жидкостью и надписью "Йод". 
        "Йод? Что это такое?" - пробормотал Йося и понюхал жидкость. От резкого запаха у него защипало в носу. 
        "Фу, какая гадость!" - поморщился ёжик. - "Наверное, это невкусно".
        Вдруг мимо пробегал зайчик. 
        "Зайка, зайка!" - крикнул Йося. - "Ты знаешь, что такое йод?"
        "Конечно, знаю," - ответил зайка. - "Йод - это лекарство. Им смазывают ранки, чтобы они быстрее заживали".
        "Лекарство?" - удивился Йося. - "А оно вкусное?"
        "Не знаю," - засмеялся зайчик. - "Я его никогда не пробовал. Йод нельзя пить!"
        Йося задумался. "Если йод - лекарство, значит, он полезный, - решил он. - А вдруг он ещё и вкусный?"
        Ёжик лизнул йод. 
        "Фу-фу-фу!" - зафыркал Йося, высунув язык. - "Какая гадость! И совсем невкусно!" 
        С тех пор Йося больше не пробовал всё подряд. Он понял, что не все интересные вещи бывают вкусными, а лекарства лучше не пробовать без надобности.
        
        <span>Йоркширский терьер Йошка</span>
        В маленьком домике жил-был йоркширский терьер по имени Йошка. Он был очень любопытным и весёлым щенком. Каждый день Йошка выходил во двор и играл со своими друзьями: попугаем Кешей и котёнком Мурзиком.
        Однажды Йошка увидел на дереве красивую птичку с ярким оперением. "Йо-хо!" - воскликнул он от восторга. Птичка испугалась и улетела, а Йошка решил научиться лазать по деревьям, чтобы познакомиться с ней поближе.
        Целый день он пытался забраться на дерево, но у него ничего не получалось. "Эй, Йошка, ты же не кошка!" - смеялся Мурзик. Но Йошка не сдавался.
        К вечеру, уставший, но довольный, Йошка всё-таки залез на нижнюю ветку дерева. "Ура! Я сделал это!" - радостно залаял он. С тех пор Йошка каждый день тренировался и вскоре стал самым ловким йоркширским терьером во всем дворе.
        Стихотворение со звуком Й:
        Маленький зайчик под елкой сидел,
        Йогурт клубничный он скушать хотел.
        «Где ты, вкусняшка», - тихонько твердил, -
        Давненько вкусняшки такой я не пил.
        Мама-зайчиха лукошко открыла
        Баночку с йогуртом зайке дала.
        «Кушай, малыш,  -  набирайся силы, - 
        Сила поможет нам делать дела!»
        `
    },
    {
        descr: `Автоматизация звука Р в слогах - это важный этап, который способствует правильному произношению данного звука в различных фонетических контекстах. Занятия начинаются с изолированного произнесения звука Р, затем переходят к слогам, содержащим этот звук в различных позициях.
        <span>"Р" в начале слога: тренируемся с прямыми слогами</span>
        Произношение звука "Р" в начале слога (в прямых слогах) помогает ребенку освоить правильную артикуляцию в этой позиции. Важно проговаривать каждый слог четко и не торопясь.
        <span>Примеры прямых слогов:</span>
        РА – РО – РУ
        РО – РА – РЫ
        РА – РЫ – РЭ
        РУ – РО – РА
        РЭ – РА – РО
        РО – РА – РЫ
        <span>"Р" в конце слога: закрепляем навык с обратными слогами</span>
        Произношение звука "Р" в конце слога (в обратных слогах) закрепляет правильную артикуляцию в этой позиции.
        <span>Примеры обратных слогов:</span>
        АР – ОР – УР
        УР – ЭР – АР
        ЭР – АР – ОР
        ОР – АР – УР
        ЫР – УР – ОР
        ЭР – УР – ЫР
        ОР – УР – ЭР
        <span>"Р" между гласными: учимся говорить красиво и плавно</span>
        Произношение звука "Р" между гласными звуками (в интервокальной позиции) помогает ребенку использовать звук в более сложных фонетических контекстах.
        <span>Примеры интервокальных слогов:</span>
        АРА – ОРО – УРУ
        УРУ – ОРО – АРА
        ЫРЫ – ЭРЭ – УРУ
        АРА – ЭРЭ – ЫРЫ
        УРУ – ЫРЫ – АРА
        ЭРЭ – АРА – ОРО
        Мягкий звук "Рь": особенности артикуляции
        Произношение мягкого звука Рь требует особого внимания к артикуляции, так как мягкий звук произносится с более высоким положением языка.
        Примеры слогов с мягким Рь:
        Ря: ря-рю-ри
        Ри: ри-рё-ря
        Ре: ре-рю-рё
        Рё: рё-ря-ре
        Рю: рю-ре-ря
        `
    },
    {
        descr: `В начале слова: радуга, робот, ракета, ручка, рассвет, рог, роза
        В середине слова: карандаш, гараж, урок, город, корона, перо, огород, овраг
        В конце слова: шар, пар, удар, пир, двор, базар, ковёр, кефир, товар
        Со стечениями согласных: граф, кровать, корм, груз, бросок, крапива, прыжок, братья
        Работа над сочетаниями ТР, ДР
        Произношение слогов с сочетаниями звуков ТР и ДР требует особого внимания. Необходимо соблюдать непрерывность произношения этих звуковых сочетаний, так как звуки Т и Д помогают удерживать язык у нёба, что необходимо для правильной артикуляции звука Р.
        Примеры упражнений:
        Произносим слоги с "ТР" и "ДР", не разрывая звуки:
        адр_, одр_, удр_, ыдр_, эдр_, идр_, едр_, ёдр_, юдр_, ядр_
        др_а, др_о, др_у, др_ы, др_э
        Произносим слова, где слог "ДРА" ударный:
        драма, дранка, квадрат, драть
        страус, стража, страны
        Произносим слова, где слог "ДРА" безударный:
        трасса, травы, трава, трамвай
        дракон, ведра, выдра, пудра
        Примеры слов с мягким "Рь":
        Ряд, рядом, рябчик, ряска
        Рябина, рис, ритм, рифма
        Ритмика, рисунок, речь, репа
        Речка, ребус, решение, рёв
        Рёва, рюмка, рюшка, рюкзак
        Эти упражнения помогают ребенку не только закрепить правильное произношение звуков Р и Рь в разных слогах и словах, но и способствуют улучшению его артикуляционных навыков, что активно готовит речевой аппарат к введению этих звуков в речь.
        После того, как ребёнок стал точно и легко проговаривать слоги и слова со звуками Р и Рь, можно переходить к закреплению этих звуков в словосочетаниях и предложениях.
        `
    },
    {
        descr: `В словосочетаниях:
        Красная роза, трудный урок, зеленый огород, река течет, пухлая рыба, солнечный рассвет,  громкий рык, пышная крона, рабочий робот, яркий фонарь
        В предложениях: 
        Рома раскрасил рисунок яркими красками, воробей весело чирикал на ветке дерева, Вера решила приготовить ароматный пирог, красная рыба плыла в прозрачной реке, на улице растет огромный кленовый лист, Роза поставила цветы в большую вазу, ворота открылись и машина въехала во двор, рекордсмен пробежал дистанцию за рекордное время, ракета взлетела и исчезла в облаках, ребята устроили пикник в зеленом парке.
        Следующим этапом после закрепления Р и Рь в словосочетаниях и предложениях будет отработка скороговорок и чтение и пересказ фонетических текстов.
        `
    },
    {
        descr: `Автоматизация звука Р в скороговорках:
        1. Раз рыба, два рыба, три рыба.
        2. На дворе трава, на траве дрова.
        3. Карл у Клары украл кораллы, а Клара у Карла украла кларнет.
        4. Рукавицы для девицы, а для рыцаря рукава.
        5. Приготовила Лера четыре эклера.
        Фонетический рассказ для чтения и пересказа со звуками Р и Рь:
        "Игрушки"
        В одном красивом доме жила маленькая девочка по имени Рита. У Риты была большая коробка с игрушками. В этой коробке лежали разноцветные роботы, мягкие медведи и резиновые утки. 
        Однажды Рита решила поиграть со своими игрушками. Она достала робота и начала его заводить. Робот громко загудел и поехал по полу, оставляя за собой разноцветные следы. Затем Рита взяла резиновую утку и пустила её плавать в ванной. Утка плавала кругами, радуя Риту своими забавными движениями.
        После этого Рита нашла своего плюшевого медведя. Медведь был такой мягкий и уютный, что Рита обняла его и стала рассказывать ему разные истории. Она рассказывала о том, как в реке живут рыбы, как красиво цветут розы в её саду, и как она любит играть на яркой детской площадке.
        Когда наступил вечер, Рита аккуратно сложила все свои игрушки обратно в коробку. Она поцеловала медведя, робота и утку на прощание и пожелала им спокойной ночи. Рита закрыла коробку и отправилась спать, мечтая о новых играх со своими любимыми игрушками.
        Для закрепления звука в речи, особую важность представляет заучивание стихотворений наизусть:
        Рома резво мчится на велосипеде,
        Разноцветные цветы рвёт он для соседей.
        Рыбы в пруду плещутся игриво,
        Рядом с ним растёт большая красивая ива.
        Игровые упражнения для автоматизации звука Р
        Проводить автоматизацию звука Р можно в игровой форме, что особенно привлекательно для детей. Такие упражнения помогают поддерживать интерес и мотивацию ребенка.
        Игра «Что поменялось?»
        Для этой игры понадобятся карточки с изображениями предметов, в названиях которых присутствует звук Р. Разложите карточки перед ребенком и попросите его назвать, что на них изображено. Если ребенок неправильно произнесет звук, повторите упражнение заново, обращая внимание на правильное произношение.
        Игра «Запомни порядок»
        Используйте те же карточки, что и в предыдущей игре. Разложите их в ряд (примерно пять штук). Попросите ребенка внимательно посмотреть на них и запомнить порядок. Затем попросите его отвернуться и назвать предметы и их порядок. Если ребенок делает ошибки, повторите упражнение, добиваясь правильного произношения.
        Игра «Вспомни больше слов»
        Эта игра удобна тем, что в нее можно играть в любом месте: дома, на улице, в машине и т.д. Суть игры – соревноваться с ребенком, кто назовет больше слов со звуком Р. Если ребенок затрудняется, предложите ему посмотреть вокруг и найти такие слова. Он может назвать дерево, траву, двор и т.д.
        Регулярные повторения и усложнение упражнений
        Для достижения четкого произношения звука Р необходимо регулярно повторять предложенные упражнения. При этом важно учитывать индивидуальные особенности ребенка. Переходите от простых заданий к более сложным, постепенно увеличивая их сложность. Упражнения можно выполнять дома вместе с ребенком. Эти задания помогут не только автоматизировать звук Р, но и развивать фонематический слух и расширять словарный запас ребенка.
        `
    },
    {
        descr: `Автоматизация звука [С] в прямых слогах:
        - СА – СА – СА – СА
        - СЫ – СЫ – СЫ – СЫ
        - СО – СО – СО – СО
        - СУ – СУ – СУ – СУ
        В обратных слогах:
        - АС – АС – АС – АС
        - ИС – ИС – ИС – ИС
        - ОС – ОС – ОС – ОС
        - УС – УС – УС – УС
        - ЕС – ЕС – ЕС – ЕС
        
        В интервокальных слогах:
        - АСА – АСО – АСЫ – АСУ
        - УСА – УСО – УСЫ – УСУ 
        - ОСА – ОСО – ОСЫ – ОСУ
        - ЫСА – ЫСО – ЫСЫ – УСУ
        
        С сочетанием согласных:
        - КСА – КСО – КСУ – КСЫ
        - СЛУ – СЛА – СЛЫ – СЛО
        - ХСЫ – ХСА – ХСО – ХСЫ
        - ПСЫ – ПСУ – ПСО – ПСА
        
        Автоматизация звука [Сь] в прямых слогах:
        - СЯ – СЯ – СЯ –СЯ 
        - СИ – СИ – СИ – СИ 
        - СЁ – СЁ – С Ё – СЁ
        - СЮ – СЮ – СЮ –СЮ 
        
        В обратных слогах:
        - АСЬ – АСЬ – АСЬ – АСЬ
        - ИСЬ – ИСЬ – ИСЬ– ИСЬ
        - ОСЬ – ОСЬ – ОСЬ – ОСЬ
        - УСЬ – УСЬ – УСЬ – УСЬ
        - ЕСЬ – ЕСЬ – ЕСЬ – ЕСЬ
        
        С сочетанием согласных:
        - КСЯ – КСЁ – КСЮ – КСИ
        - СЛЮ – СЛЯ – СЛИ – СЛЁ
        - ХСИ – ХСЯ – ХСЁ – ХСИ
        - ПСИ – ПСЮ – ПСЁ – ПСЯ
        `
    },
    {
        descr: `Слова для автоматизации звука [С]:
        Вот 10 слов со звуком "С":
        
        1. Санки
        2. Сова
        3. Стул
        4. Соль
        5. Свет
        6. Спас
        7. Спорт
        8. Сказка
        9. Слон
        10. Страна
        Слова для автоматизации звука [Сь]:
        1. Гусята
        2. Осень
        3. Сима
        4. Семечки
        5. Сирень
        6. Косит
        7. Василёк
        8. Секрет
        9. Селёдка
        10. Моюсь
        `
    },
    {
        descr: `Предложения для автоматизации звука [С]:
        1. Светлая солнечная погода радовала горожан.
        2. Старый садовник бережно ухаживал за своими розами.
        3. Дети смеялись, катаясь на санках с горки.
        4. Собака радостно виляла хвостом, встречая своего хозяина.
        5. На столе лежала открытая книга со стихами.
        6. Спортсмен упорно тренировался, чтобы победить в соревнованиях.
        7. Сладкий аромат свежей выпечки разносился по дому.
        8. Самолёт пролетел высоко в небе, оставляя белый след.
        9. Серебристая луна освещала спящий город.
        10. Маленькая девочка с интересом слушала сказку на ночь.
        Предложения для автоматизации звука [Сь]:
        1. Сима пасёт гусей.
        2. Вася сидит на стуле.
        3. Люсе семь лет.
        4. Ася едет на север.
        5. Сеня ест персики.
        6. Люся посадила сирень.
        7. Стёпе подарили новый свитер.
        8. В степи растут васильки.
        9. Вася косит траву.
        10. Ася смеётся.
        `
    },
    {
        descr: `<span>Сказка про Соню и Слона</span>
        Жила-была девочка Соня. Любила она слушать сказки про разных зверей. Однажды сила она сладкий сон, и приснился ей седой слон. Слон был большой и добрый, с огромными ушами и смешным хоботом.
        – Здравствуй, Соня! – прогудел слон. – Я – северный слон, и я умею говорить!
        – Здравствуй, слон! – удивилась Соня. – А почему ты северный?
        – Потому что я живу на севере, где много снега и сосулек, – объяснил слон. – А ты любишь снег?
        – Конечно, люблю! – сказала Соня. – Давай слепим снеговика!
        И они стали лепить снеговика. Сначала скатали большой снежный ком, потом поменьше, а потом ещё меньше. Сделали снеговику глаза из сосулек, нос из сосновой шишки и рот из сучка. Получился смешной снеговик!
        – «Спасибо тебе, слон», – сказала Соня. – Мне было очень весело!
        – «А мне было приятно с тобой познакомиться», – сказал слон. – Приходи ещё спать, будем снова играть!
        И Соня проснулась. Она посмотрела в окно – там шёл снег. Скорее бы на улицу лепить снеговика!
        
        
        Стихотворение со звуками С и Сь: 
        Снег сегодня сыплет с неба,
        Словно сыплет кто-то с веток.
        Спит сосна, укрывшись снегом,
        Спит сова, укрывшись снегом.
        Спит собака, свернувшись в клубок,
        Спит сынок, укрывшись в свой уголок.
        Спят деревья, укрывшись снежком,
        Спит деревня, укрывшись тишиной, как платком.
        `
    },
    {
        descr: `Ца – Ца – Ца
        Цо – Цо – Цо 
        Цу – Цу – Цу 
        аЦ – аЦ – аЦ  
        оЦ – оЦ – оЦ
        аЦ – оЦ – еЦ
        еЦ – иЦ – оЦ
        иЦ – аЦ – еЦ
        оЦ – иЦ – аЦ
        Примеры слов со звуком Ц:
        1.	Цвет
        2.	Цель
        3.	Цапля
        4.	Цирк
        5.	Цветок
        6.	Церковь
        7.	Цыпленок
        8.	Цунами
        9.	Цыган
        10.	Цыпа
        `
    },
    {
        descr: `Звук Ц в словосочетаниях:
        1.	Цветная цепь
        2.	Царская цапля
        3.	Целая цистерна
        4.	Цифровой циферблат
        5.	Цепкий цемент
        6.	Целебный цвет
        7.	Цыганский цыпленок
        8.	Царский церемониал
        9.	Центральная цель
        10.	Цветущий цветник
        
        Звук Ц в предложениях:
        1.	Цыпленок целый день искал зернышки на цветочной клумбе.
        2.	Цыган играл на гитаре мелодию про цветущий сад.
        3.	На арену цирка вывели огромного индийского слона.
        4.	Бабушка испекла вкусный пирог с цукатами и посыпала его цветной посыпкой.
        5.	Цапля важно вышагивала по болоту, высматривая лягушек.
        6.	Строители использовали цемент для возведения стен нового дома.
        7.	Царь сидел на троне в царских одеждах и слушал своих советников.
        8.	Стрелки на циферблате показывали ровно двенадцать часов.
        9.	В вазе стоял букет из ароматных лилий и нежных цинний.
        10.	Цифра десять является круглой цифрой.
        `
    },
    {
        descr: `<span>Цыпленок Цыпа и волшебный цветок</span>
        Жил на свете маленький цыпленок по имени Цыпа. Был он желтый, пушистый, но очень уж неуклюжий. То споткнется, то упадет, то чихнет так, что все цыплята разбегутся.
        Однажды гулял Цыпа по двору и увидел удивительную вещь – под старой яблоней расцвел волшебный цветок. Лепестки у него были разноцветные: красный, оранжевый, желтый, зеленый, голубой, синий, фиолетовый. А в серединке цветка сиял маленький огонек.
        Подошел Цыпа поближе, потрогал лепесток лапкой. И вдруг цветок заговорил!
        — Здравствуй, Цыпа, — прозвенел тоненький голосок. — Я – волшебный цветок. Если ты соберешь с моих лепестков утреннюю росу и выпьешь ее, то перестанешь быть таким неуклюжим.
        Обрадовался Цыпа. Стал он ждать утра. Как только взошло солнце, собрал цыпленок с лепестков серебристые капельки росы и выпил.
        И что вы думаете? Цыпа сразу почувствовал себя сильным и ловким. Он больше не спотыкался, не падал и не чихал так громко. Цыпленок весело бегал по двору, играл с другими цыплятами и радовался жизни.
        С тех пор все называли его не иначе как Цыпа-молодец!
        
        Стихотворение со звуком Ц:
        Цыпленок Цып на цыпочках шагал,
        Он новый цирк сегодня открывал.
        Там на арене цирковой, блестя,
        Цапелька пляшет, кружа.
        `
    },
    {
        descr: `Автоматизация звука [З] в прямых слогах:
        - ЗА – ЗА – ЗА – ЗА
        - ЗЫ – ЗЫ – ЗЫ – ЗЫ
        - ЗО – ЗО – ЗО – ЗО
        - ЗУ – ЗУ – ЗУ – ЗУ
        В обратных слогах:
        - АЗ – АЗ – АЗ – АЗ
        - ИЗ – ИЗ – ИЗ – ИЗ
        - ОЗ – ОЗ – ОЗ – ОЗ
        - УЗ – УЗ – УЗ – УЗ
        - ЕЗ – ЕЗ – ЕЗ – ЕЗ
        
        В интервокальных слогах:
        - АЗА – АЗО – АЗЫ – АЗУ
        - УЗА – УЗО – УЗЫ – УЗУ 
        - ОЗА – ОЗО – ОЗЫ – ОЗУ
        - ЫЗА – ЫЗО – ЫЗЫ – УЗУ
        
        С сочетанием согласных:
        - КЗА – КЗО – КЗУ – КЗЫ
        - ЗЛУ – ЗЛА – ЗЛЫ – ЗЛО
        - ХЗЫ – ХЗА – ХЗО – ХЗЫ
        - ПЗЫ – ПЗУ – ПЗО – ПЗА
        
        Автоматизация звука [Зь] в прямых слогах:
        - ЗЯ – ЗЯ – ЗЯ – ЗЯ 
        - ЗИ – ЗИ – ЗИ – ЗИ 
        - ЗЁ – ЗЁ – ЗЁ – ЗЁ
        - ЗЮ – ЗЮ – ЗЮ – ЗЮ 
        
        В обратных слогах:
        - АЗЬ – АЗЬ – АЗЬ – АЗЬ
        - ИЗЬ – ИЗЬ – ИЗЬ– ИЗЬ
        - ОЗЬ – ОЗЬ – ОЗЬ – ОЗЬ
        - УЗЬ – УЗЬ – УЗЬ – УЗЬ
        - ЕЗЬ – ЕЗЬ – ЕЗЬ – ЕЗЬ
        
        С сочетанием согласных:
        - КЗЯ – КЗЁ – КЗЮ – КЗИ
        - ЗЛЮ – ЗЛЯ – ЗЛИ – ЗЛЁ
        - ХЗИ – ХЗЯ – ХЗЁ – ХЗИ
        - ПЗИ – ПЗЮ – ПЗЁ – ПЗЯ
        `
    },
    {
        descr: `Слова для автоматизации звука [З]:
        1.	Завод
        2.	Звезда
        3.	Заяц
        4.	Закат
        5.	Зоя
        6.	Завтрак
        7.	Загадка
        8.	Замок
        9.	Ваза
        10.	Болезнь
        
        Слова для автоматизации звука [Зь]:
        1. Озёра
        2. Везёт
        3. Бузина
        4. Морозить
        5. Зима
        6. Корзина
        7. Зелень
        8. Зеркало
        9. Газета
        10. Хозяин
        `
    },
    {
        descr: `Статья:
        1.	Зелёный змей летел по небу, оставляя за собой золотистый след.
        2.	За окном завывала метель, а в доме было тепло и зажигали свечи.
        3.	Злюка заметила добычу и стала тихонько подкрадываться.
        4.	Звонкий звук колокольчика разбудил спящую красавицу.
        5.	Заяц задрожал от страха, увидев лису.
        6.	Золотая рыбка загадала три желания старику.
        7.	Зимой медведь спит в берлоге, а змея – в норе.
        8.	Маленькая звездочка упала с неба, и зелье желание.
        9.	Злой волшебник превратил принца в забавную лягушку.
        10.	Завтра мы пойдем в зоопарк и увидим там зебру и зубра.
        `
    },
    {
        descr: `Автоматизация звуков З и Зь в скороговорках:
        1.	За забором зайка зябнет, замерзают зайки лапки.
        2.	Зина зовёт Зинаиду за земляникой на лужайку.
        3.	Зима злится, снег кружится, вьюга злая веселится.
        4.	На зелёной лужайке звонко звенят комарики.
        5.	Злая коза завязала бантик на берёзе.
        6.	Зинаида не любит изюм - говорит, зубы ломит.
        7.	У зеленого забора звонко звенят бубенчики, за забором козы бродят, зелень щипать норовят.
        8.	Зина упала на пол, разбила банку с зефиром. Зря Зинаида зефир не ела, вот и осталась ни с чем!
        
        
        Фонетический рассказ для чтения и пересказа со звуками З и Зь:
        <span>Зайка Зяба и золотая звездочка</span>
        Жил в дремучем лесу зайка по имени Зяба. Был он трусливый, всё время дрожал: и от каждого шороха, и от каждого чиха.
        Однажды зимним вечером сидел Зяба под кустом, засыпал. Вдруг с неба упала яркая звёздочка – прямо к Зябе в лапки! Звёздочка была маленькая, но очень красивая, золотая и тёплая.
        Зяба испугался сначала, хотел убежать. Но звёздочка прошептала тоненьким голоском:
        — Не бойся, Зяба, я не сделаю тебе ничего плохого. Я – волшебная звёздочка. Если ты будешь хранить меня и никому не отдашь, то станешь самым смелым зайкой в лесу!
        Обрадовался Зяба. Спрятал звёздочку за пазуху поближе к сердцу, и сразу почувствовал себя храбрее. Больше не боялся он ни волка, ни лису, ни даже филина.
        Стал Зяба защищать слабых, помогать друзьям, перестал дрожать от каждого звука. И все звери в лесу удивлялись: как это трусливый Зяба стал таким смелым? А секрет был прост: доброе сердце и маленькая золотая звёздочка!
        
        Звуки З и Зь в стихотворении: 
        Зайка Зяба в поле скачет,
        Звонко песенку поёт.
        Звёздочка на небе синем,
        Светит Зябе ясным днём,
        Спит она лишь в небе дымном,
        Когда тучка льёт дождём.
        `
    },
    {
        descr: `Автоматизация звука [Ш] в прямых слогах:
        - ША – ША – ША – ША
        - ШЭ – ШЭ – ШЭ – ШЭ
        - ШО – ШО – ШО – ШО
        - ШУ – ШУ – ШУ – ШУ
        В обратных слогах:
        - АШ – АШ – АШ – АШ
        - ИШ – ИШ – ИШ – ИШ
        - ОШ – ОШ – ОШ – ОШ
        - УШ – УШ – УШ – УШ
        - ЕШ – ЕШ – ЕШ – ЕШ
        
        В интервокальных слогах:
        - АША – АШО – АШИ – АШУ
        - УША – УШО – УШИ – УШУ 
        - ОША – ОШО – ОШИ – ОШУ
        - ЫША – ЫШО – ЫШИ – УШУ
        
        С сочетанием согласных:
        - КША – КШО – КШУ – КШИ
        - СШУ – США – СШИ – СШО
        - ФШО – ФШУ – ФША – ФШИ
        - ХШЫ – ХША – ХШО – ХШИ
        - ПШИ – ПШУ – ПШО – ПША
        Автоматизация звука [Ж] в прямых слогах:
        - ЖА – ЖА – ЖА – ЖА
        - ЖЭ – ЖЭ – ЖЭ – ЖЭ
        - ЖО – ЖО – ЖО – ЖО
        - ЖУ – ЖУ – ЖУ – ЖУ
        В обратных слогах:
        - АЖ – АЖ – АЖ – АЖ
        - ИЖ – ИЖ – ИЖ – ИЖ
        - ОЖ – ОЖ – ОЖ – ОЖ
        - УЖ – УЖ – УЖ – УЖ
        - ЕЖ – ЕЖ – ЕЖ – ЕЖ
        
        В интервокальных слогах:
        - АЖА – АЖО – АЖИ – АЖУ
        - УЖА – УЖО – УЖИ – УЖУ 
        - ОЖА – ОЖО – ОЖИ – ОЖУ
        - ЫЖА – ЫЖО – ЫЖИ – УЖУ
        
        С сочетанием согласных:
        - КЖА – КЖО – КЖУ – КЖИ
        - СЖУ – СЖА – СЖИ – СЖО
        - ФЖО – ФЖУ – ФЖА – ФЖИ
        - ХЖИ – ХЖА – ХЖО – ХЖИ
        - ПЖИ – ПЖУ – ПЖО – ПЖА
        `
    },
    {
        descr: `Слова для автоматизации звука [Ш]:
        1. Шум
        2. Шапка
        3. Мышь
        4.Школа
        5. Карандаш
        6. Малыш
        7. Ландыш
        8. Шахтёр
        9. Шило
        10. Тишина
        Слова для автоматизации звука [Ж]:
        1. Жираф
        2. Жук
        3. Жажда
        4. Жарко
        5. Муж
        6. Ежик
        7. Нож
        8. Лужа
        9. Жалеть
        10. Ужин
        `
    },
    {
        descr: `Предложения для автоматизации звука [Ш]:

        1. Шаловливый щенок шуршал шишками в шалаше.
        2. Маша шила шелковой ниткой шапку для малыша.
        3. Мышка шуршала, шуршала, да и нашла вкусный сыр.
        4. Шмель жужжит, шуршит крыльями, ищет ароматный цветок.
        5. В тишине слышно, как шуршат шины машины по шоссе.
        6. Шустрый мышонок шмыгнул в норку, испугавшись кошки.
        7. Бабушка шинковала капусту, готовя вкусный борщ.
        8. Хорошая книга увлекает, словно ты сам шагаешь по ее страницам.
        9. Тише едешь, дальше будешь, шептал старый конь.
        10. Шершавый язык кошки щекотал ладошку малыша.
        
        Предложения для автоматизации звука [Ж]:
        1. Жираф жевал сочные зеленые ветки.
        2. Жужжит жук, над лугом кружит, свою добычу сторожит.
        3. В жаркий день так хочется пить, мучает жажда.
        4. Желтые листья, словно золотые монетки, падают с деревьев.
        5. Ежик топал по лесу, шурша сухими листьями.
        6. Мальчик нашел на дороге красивого жука и посадил его на ладонь.
        7. Бабушка жарила вкусные пирожки с капустой и яйцом.
        8. За окном дождь, а мы сидим дома и пьем горячий чай.
        9. Пожелай мне удачи, и я обязательно справлюсь с этим заданием!
        10. Жизнь прекрасна и удивительна, нужно только уметь это видеть!
        `
    },
    {
        descr: `Шумливый Жук
        Жил-был на лесной опушке маленький жучок. Звали его Жужа. Был он очень шумливый. Летал Жужа по полянке и всё время жужжал: "Ж-ж-ж!". 
        Однажды, спрятавшись в шалфее, Жужа услышал странный звук: "Ш-ш-ш!".  "Что это может быть?", - подумал Жужа и решил разведать.  Пробирался он сквозь густую траву, раздвигал зелёные листочки, а звук всё приближался: "Ш-ш-ш!".
        И вдруг Жужа увидел смешного пушистого зверька. Зверёк сидел под кустом шиповника и шелушил шишку. "Привет! Ты кто?" - спросил Жужа. "Я мышонок, меня зовут Шустрик. А ты кто?" - пискнул зверек.  "Я - Жужа! Давай дружить!", -  радостно зажужжал жучок. 
        С тех пор Жужа и Шустрик - лучшие друзья. Вместе шелестят шишками, жужжат и шуршат травой, а вечерами Жужа рассказывает Шустрику сказки, убаюкивая его тихим "ж-ж-ж".
        Стихотворение со звуками Ш и Ж: 
        Жук жужжит, на солнце греется,
        В шалфее душистом шевелится.
        Шустро лапками перебирает,
        Жаркий день – летать обещает!
        Шмель большой, мохнатый, важный,
        Пролетел, на Жужу не глядя даже.
        Шумно крыльями своими машет,
        Аромат цветов душистых жаждет.
        `
    },
    {
        descr: `Автоматизация звука [Ч’] в обратных слогах:
        АЧ – ОЧ         ОЧ – УЧ           УЧ – ЫЧ        ЫЧ – ИЧ  
        ИЧ – ЕЧ          ЕЧ – ЁЧ           ЁЧ – ЮЧ        ЮЧ – ЯЧ
        В обратных слогах со стечением согласных:
        АЧК – ОЧК – УЧК – ЫЧК
        ИЧК – ЕЧК – ЁЧК – ЮЧК – ЯЧК
        АЧТ – ОЧТ – УЧТ – ЫЧТ
        ИЧТ – ЕЧТ – ЁЧТ – ЮЧТ – ЯЧТ
        В прямых слогах:
        ЧА – ЧА – ЧА – ЧА – ЧА
        ЧО – ЧО – ЧО – ЧО – ЧО
        ЧУ – ЧУ – ЧУ – ЧУ – ЧУ
        ЧИ – ЧИ – ЧИ – ЧИ – ЧИ
        ЧЕ – ЧЕ – ЧЕ – ЧЕ – ЧЕ
        В интервокальных слогах:
        АЧА – АЧО – АЧУ – АЧИ
        УЧА – УЧО – УЧУ – УЧИ
        ОЧА – ОЧО – ОЧУ – ОЧИ
        ИЧА – ИЧО – ОЧУ – ИЧИ
        В прямых слогах со стечением согласных:
        ЧТА – ЧТО – ЧТУ – ЧТИ – ЧТЕ
        ЧМА – ЧМО – ЧМУ – ЧМИ – ЧМЕ
        ЧКА – ЧКО – ЧКУ – ЧКИ – ЧКЕ
        ЧНА – ЧНО – ЧНУ – ЧНИ – ЧНЕ
        Примеры слов со звуком Й:
        1. Чашка
        2. Ночка
        3. Речка
        4. Дочка
        5. Печка
        6. Тучка
        7. Птичка
        8. Вещички
        9. Читать
        10. Молчать
        `
    },
    {
        descr: `Звук Ч в словосочетаниях: 
        1. Чудесный вечер
        2. Черная кошка
        3. Чашка кофе
        4. Чистый лист
        5. Часы тикают
        6. Читать книгу
        7. Человек с чемоданом
        8. Чудо природы
        9. Черный чай
        10. Черника в лесу
        
        Звук Ч в предложениях:
        1. Часы показывают четыре часа.
        2. Черная кошка чирикала на окне.
        3. Чудесный закат окрасил небо в розовый цвет.
        4. Человек с чемоданом спешил на поезд.
        5. Чили - это острое блюдо из перца.
        6. Читать книги - отличное занятие для ума.
        7. Черника растет в лесу и собирается в корзину.
        8. Чашка с ароматным кофе стояла на столе.
        9. Черепаха медленно ползала по песку.
        10. Чистый воздух в парке наполнял легкость и свежестью.
        `
    },
    {
        descr: `Жили-были в далеком лесу три маленькие черепахи: Чип, Чап и Чуп. Они были лучшими друзьями и всегда проводили время весело вместе. У них был свой маленький домик под большим чистым листом у речки.
        Однажды, когда наступила холодная осень, Чип, Чап и Чуп решили отправиться на поиски чудесного сокровища, о котором им рассказывала их бабушка Черепаха Чародейка. Она говорила, что это сокровище может исполнить любое желание.
        Так, в один ясный день, три друга отправились в путь. Они прошли через чащу чащобы, чирикая и чиркая, и наконец добрались до чудесного озера. Там, на дне озера, они нашли чудесную чашку, усыпанную драгоценными чемоданами.
        Чип, Чап и Чуп, испугавшись вдруг часов, решили не терять времени и быстро вернуться домой. По пути они встретили человека с черными часами, который рассказал им, что сокровище - это не чудо, а просто шутка судьбы.
        Так, вернувшись домой, Чип, Чап и Чуп поняли, что настоящее сокровище - это дружба и взаимопомощь. Они стали еще крепче дружить и каждый день проводить весело вместе, радуясь чудесной жизни в лесу.
        Стихотворение со звуком Ч:
        Чижик-пыжик, где ты был?
        Чай с черникой ты не пил?
        Я на веточке чирикал,
        Часик целый отдыхал!
        Солнце село, вечер тих,
        Чайник новый в доме стих.
        Чашки ждут на скатерти,
        Чай пить будем – я и ты!
        `
    },
    {
        descr: `Автоматизация Щ в прямых слогах:
        ЩА – ЩА – ЩА       ЩА – ЩО – ЩУ 
        ЩО – ЩО – ЩО      ЩИ – ЩЕ – ЩА 
        ЩУ – ЩУ – ЩУ        ЩО – ЩЕ – ЩИ  
        ЩИ – ЩИ – ЩИ       ЩУ – ЩО – ЩЕ 
        ЩЕ – ЩЕ – ЩЕ         ЩЕ – ЩА – ЩО
        
        В обратных слогах:
        АЩ – АЩ – АЩ        АЩ – ОЩ – УЩ 
        ОЩ – ОЩ – ОЩ       ЫЩ – ИЩ – ЕЩ 
        УЩ – УЩ – УЩ         ЁЩ – ЮЩ – ЯЩ 
        ИЩ – ИЩ – ИЩ        УЩ – АЩ – ОЩ  
        ЕЩ – ЕЩ – ЕЩ          ИЩ – ЯЩ – УЩ
        
        В интервокальной позиции:
        АЩА – АЩО – АЩУ – АЩИ 
        ОЩА – ОЩО – ОЩУ – ОЩИ
        УЩА – УЩО – УЩУ – УЩИ
        ИЩА – ИЩО – ИЩУ – ИЩ
        `
    },
    {
        descr: `1. Щетка
        2. Щенок
        3. Вещи
        4. Щи
        5. Щавель
        6. Щель
        7. Плащ
        8. Хрящ
        9. Ища (деепричастие от "искать")
        10. Пищит
        `
    },
    {
        descr: `В словосочетаниях:
        1. Зубная щётка
        2. Маленький щенок
        3. Густые щи
        4. Полезная пища
        5. Узкая щель
        6. Новый плащ
        7. Хрустящий хрящ
        8. Тщательно ища
        9. Пронзительно пищит
        10. Настоящие щи
        В предложениях:
        1. Маленький щенок радостно вилял хвостом, встречая хозяина.
        2. Повар налил в тарелку ароматные щи со сметаной.
        3. Щука - хищная рыба, обитающая в пресных водоёмах.
        4. Мама купила новую щётку для одежды.
        5. Мы долго искали ключи, тщательно проверяя каждый ящик.
        6. В узкой щели между камнями рос хрупкий цветок.
        7. Осенью люди надевают плащи, чтобы защититься от дождя.
        8. Собака грызла кость, с аппетитом хрустя хрящом.
        9. Малыш громко пищит, прося маму взять его на ручки.
        10. Вкусные щи согрели нас после прогулки по зимнему лесу. 
        `
    },
    {
        descr: `Щёчки для поцелуев
        Жил-был на свете маленький Щенок. Он был очень славный: пушистый, с чёрными бусинками-глазками и розовым носом. Больше всего на свете Щенок любил, когда его чесали за ушком и целовали в щёчку. 
        Однажды Щенок гулял по двору и увидел девочку Машу. Маша плакала. 
        – Что случилось? – обеспокоенно спросил щенок. 
        – Я потеряла свою любимую щётку для волос, – всхлипнула Маша. –  Без неё мои косички не получатся красивыми! 
        Щенок решил помочь девочке. Он тщательно обнюхал двор, заглянул под скамейку, обследовал каждый кустик. И наконец, нашёл щётку! Она лежала под кустом пиона.
        – Вот она! – радостно завилял хвостиком щенок и протянул Маше щётку. 
        Девочка так обрадовалась! Она крепко обняла щенка и поцеловала его в щёчку. 
        – Спасибо тебе, ты настоящий друг! – сказала Маша. 
        С тех пор Маша и щенок стали лучшими друзьями.  Каждый день они играли вместе, а щенок всегда с радостью подставлял свои щёчки для поцелуев.
        Стихотворение со звуком Щ:
        Щенок пушистый, словно ком,
        Звенит от игр целый дом!
        Щекочет носиком ладошку,
        И просит вкусную картошку.
        
        Щебечет птичка за окном,
        Весна пришла уже кругом!
        И щенок, забыв про сон,
        Бежит встречать весенний звон!
        `
    },
];

export default learningMaterialsArr;